const Animals = Object.freeze([
  'Badger',
  'Bear',
  'Cat',
  'Cow',
  'Dog',
  'Donkey',
  'Elephant',
  'Frog',
  'Giraffe',
  'Koala',
  'Lemur',
  'Lizard',
  'Lynx',
  'Meerkat',
  'Moose',
  'Mosquito',
  'Mouse',
  'Otter',
  'Owl',
  'Panda',
  'Pelican',
  'Puma',
  'Rabbit',
  'Snow leopard',
]);

export { Animals };
